export default {
  title: 'Listado de empresas en las que aparece como usuario',
  message: `Las empresas mostradas a continuación son aquellas donde usted aparece como usuario. Para acceder es necesario que posea el certificado correspondiente para cada usuario. Al clicar sobre el icono, la aplicación se desconectará y será dirigido de nuevo al log-in`,
  table: {
    username: 'Usuario',
    company: 'Empresa',
    logout: 'Acceder'
  }
}
